import type { TextKey } from "../../i18n/en.ts";
import type { GeojsonGeometryType } from "./detectLayers.ts";

export type ImportTargetSection =
  | "JUNCTIONS"
  | "OUTFALLS"
  | "STORAGE"
  | "DIVIDERS"
  | "CONDUITS"
  | "PUMPS"
  | "ORIFICES"
  | "WEIRS"
  | "OUTLETS"
  | "SUBCATCHMENTS";

export const IMPORT_TARGETS_BY_GEOMETRY: Record<GeojsonGeometryType, ImportTargetSection[]> = {
  Point: ["JUNCTIONS", "OUTFALLS", "STORAGE", "DIVIDERS"],
  LineString: ["CONDUITS", "PUMPS", "ORIFICES", "WEIRS", "OUTLETS"],
  Polygon: ["SUBCATCHMENTS"],
};

/** Shared by importLayer.ts and crsResolution.ts — keep as the one source of this grouping, don't let a second copy drift out of sync. */
export const NODE_TARGET_SECTIONS = new Set<ImportTargetSection>([
  "JUNCTIONS",
  "OUTFALLS",
  "STORAGE",
  "DIVIDERS",
]);

export const LINK_TARGET_SECTIONS = new Set<ImportTargetSection>([
  "CONDUITS",
  "PUMPS",
  "ORIFICES",
  "WEIRS",
  "OUTLETS",
]);

export const IMPORT_TARGET_LABEL_KEY: Record<ImportTargetSection, TextKey> = {
  JUNCTIONS: "kind.junction",
  OUTFALLS: "kind.outfall",
  STORAGE: "kind.storage",
  DIVIDERS: "kind.divider",
  CONDUITS: "kind.conduit",
  PUMPS: "kind.pump",
  ORIFICES: "kind.orifice",
  WEIRS: "kind.weir",
  OUTLETS: "kind.outlet",
  SUBCATCHMENTS: "kind.subcatchment",
};
